module.exports = __webpack_public_path__ + "img/ACORN-U.ff4155bd.svg";